
function toggleVisibility(element_id) {
  var a = document.getElementById(element_id).style;
  a.display = a.display == 'none' ? 'block' : 'none';
}

function autoDetectAndViewImage(e, viewer_id) {
  holder = document.getElementById(viewer_id);
  if (detectType(e.value) == "svg") {
    holder.innerHTML = e.value.replace('<svg ', '<svg height="150px" width="150px" ')
  } else if (detectType(e.value) == "icon") {
    holder.innerHTML = e.value.replace('<i ', '<i style="font-size:150px;" ')
  } else {
    holder.innerHTML = `<img height='150' width='150' src='${e.value}' />`
  }
}

function detectType(data) {
  if(data.trim().startsWith("<svg ")) {
    return "svg"
  } else if(data.trim().startsWith("<i ")) {
    return "icon"
  } else if(data.trim().startsWith("http")) {
    return "url"
  } else if(data.trim().startsWith("data:")) {
    return "base64"
  } else {
    return "unknown"
  }
}

export { toggleVisibility, autoDetectAndViewImage, detectType }
export default {
  detectType,
  toggleVisibility,
  autoDetectAndViewImage
}
